import React from 'react'
import FolderDetailView from './FolderDetailView'
import FolderNameModal from './FolderNameModal'
import SelectTrivvysModal from './SelectTrivvysModal'
import FolderDeleteModal from './FolderDeleteModal'
import { getFolderItemCount, getFolderNoun } from './folderService'

// Parent tab label for the folder-page breadcrumb, keyed by folder category.
const FOLDER_TAB_LABEL = {
  SURVEY: 'Surveys',
  KNOWLEDGE_CHECK: 'Knowledge Checks',
  MESSAGE: 'Messages',
  LIBRARY: 'Library',
}

// The full folder overlay set shared by every list screen: the folder-page
// header (rendered inline) plus the create/rename, add/move and add-existing
// modals (rendered via reactstrap portals). Every screen renders one of these,
// wired to its `folderHandlers` (from makeFolderHandlers) and folder state.
const FolderModals = ({
  handlers,
  inFolderView,
  activeFolder,
  activeFolderCount,
  isAdmin,
  folderNameModal,
  selectTrivvysModalOpen,
  folderMembership,
  unfolderedCandidates,
  addExistingGetLabel,
  deleteFolderModal,
}) => {
  const folderNoun = getFolderNoun(handlers && handlers.category)
  const createFolderSubtitle =
    'Group related ' + folderNoun + ' by team, location, campaign, or topic.'
  // "Add existing" picker header: name the target folder + noun so it reads
  // plainly, e.g. Add surveys to "Onboarding".
  const addFolderName =
    activeFolder && activeFolder.name ? activeFolder.name : ''
  const addExistingTitle = `Add ${folderNoun} to "${addFolderName}"`
  const addExistingSubtitle = `Select ${folderNoun} not yet in a folder to add to this folder.`
  const folderParentLabel =
    (handlers && FOLDER_TAB_LABEL[handlers.category]) || 'Back'
  const deleteTarget =
    deleteFolderModal && deleteFolderModal.folder
      ? deleteFolderModal.folder
      : null
  const deleteTargetCount = deleteTarget
    ? getFolderItemCount(folderMembership, deleteTarget._id)
    : 0

  return (
    <React.Fragment>
      {inFolderView && (
        <FolderDetailView
          folder={activeFolder}
          itemCount={activeFolderCount}
          itemNoun={folderNoun}
          parentLabel={folderParentLabel}
          isAdmin={isAdmin}
          onBack={handlers.closeFolder}
          onAddExisting={handlers.openSelectTrivvysModal}
          onRename={() => handlers.openFolderNameModalRename(activeFolder)}
          onDelete={() => handlers.handleDeleteFolder(activeFolder)}
        />
      )}

      {folderNameModal && folderNameModal.open && (
        <FolderNameModal
          open={folderNameModal.open}
          title={
            folderNameModal.mode === 'rename'
              ? 'Rename folder'
              : 'Create folder'
          }
          subtitle={
            folderNameModal.mode === 'rename' ? '' : createFolderSubtitle
          }
          confirmLabel={
            folderNameModal.mode === 'rename' ? 'Save' : 'Create folder'
          }
          initialName={
            folderNameModal.folder ? folderNameModal.folder.name : ''
          }
          onClose={handlers.closeFolderNameModal}
          onSave={handlers.handleFolderNameSave}
        />
      )}

      {selectTrivvysModalOpen && (
        <SelectTrivvysModal
          open={selectTrivvysModalOpen}
          candidates={unfolderedCandidates}
          title={addExistingTitle}
          subtitle={addExistingSubtitle}
          getLabel={addExistingGetLabel}
          onClose={handlers.closeSelectTrivvysModal}
          onConfirm={handlers.handleAddExistingToFolder}
          onLoadMore={handlers.loadMoreCandidates}
        />
      )}

      {deleteFolderModal && deleteFolderModal.open && (
        <FolderDeleteModal
          open={deleteFolderModal.open}
          folder={deleteTarget}
          itemCount={deleteTargetCount}
          itemNoun={folderNoun}
          parentLabel={folderParentLabel}
          onCancel={handlers.closeDeleteFolder}
          onConfirm={handlers.confirmDeleteFolder}
        />
      )}
    </React.Fragment>
  )
}

export default FolderModals
